import { compose } from "redux";
import classNames from "classnames";
import React, { PureComponent } from "react";
import { Grid, Tooltip } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

class WorkScheduleReportItem extends PureComponent {
  render() {
    const { children, classes, title, TooltipProps } = this.props;

    return (
      <Tooltip title={title} enterDelay={1000} {...TooltipProps}>
        <Grid
          xs
          item
          container
          className={classNames(classes.root, "WorkScheduleReportItem")}
        >
          {children}
        </Grid>
      </Tooltip>
    );
  }
}

WorkScheduleReportItem.defaultProps = {
  title: "",
};

const styles = theme => ({
  root: {
    cursor: "default",
    position: "relative",
    borderLeft: theme.altus.workScheduleReport.defaultBorder,
    "&:first-of-type": {
      borderLeft: 0,
    },
  },
});

export default compose(withStyles(styles))(WorkScheduleReportItem);
